import { readonly, ref } from 'vue'

const notificationsUnavailable = ref(false)

export const setNotificationsUnavailable = (value: boolean) => {
  notificationsUnavailable.value = value
}

export const notificationsUnavailableState = readonly(notificationsUnavailable)
